import { IV1GetUserRecommendationsResponse1 } from '../repositories/newbuilding-search/entities/get_user_recommendations/V1GetUserRecommendationsResponse1';
import { IBuilder, INewbuildingsRecommendations } from '../types/newbuildingRecommendations';

export function prepareNewbuildingRecommendations(
  rawRecommendations?: IV1GetUserRecommendationsResponse1,
): INewbuildingsRecommendations {
  if (!rawRecommendations) {
    return {
      recommendations: [],
      allRecommendations: { link: '' },
    };
  }

  const recommendations = rawRecommendations.recommendations.map(item => {
    const builder: IBuilder | null =
      item.builders?.[0] && item.builders?.[0].logoUrl
        ? { ...item.builders[0], logoUrl: item.builders[0].logoUrl }
        : null;

    return {
      ...item,
      builder,
      address: item.address ?? undefined,
    };
  });

  return {
    ...rawRecommendations,
    recommendations,
  };
}
